/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
const hasTelemetryPropFunctions = (x) => typeof x?.getTelemetryProperties === "function" &&
    typeof x?.addTelemetryProperties === "function";
/**
 * Type guard for error data containing the {@link IFluidErrorBase.errorInstanceId} property.
 *
 * @internal
 */
export const hasErrorInstanceId = (x) => typeof x?.errorInstanceId === "string";
/**
 * Type guard for {@link IFluidErrorBase}.
 *
 * @internal
 */
export function isFluidError(error) {
    return (typeof error?.errorType === "string" &&
        typeof error?.message === "string" &&
        hasErrorInstanceId(error) &&
        hasTelemetryPropFunctions(error));
}
//# sourceMappingURL=fluidErrorBase.js.map